// Action types for ranked competitions management
export const CREATE_RANKED_ROUND = "CREATE_RANKED_ROUND";
export const UPDATE_RANKED_ROUND = "UPDATE_RANKED_ROUND";
export const DELETE_RANKED_ROUND = "DELETE_RANKED_ROUND";
export const FETCH_RANKED_ROUND_SUBMISSIONS = "FETCH_RANKED_ROUND_SUBMISSIONS";
export const UPDATE_LEADERBOARD = "UPDATE_LEADERBOARD";
export const FETCH_RANKED_ROUNDS = "FETCH_RANKED_ROUNDS";
